import { TextInput, type TextInputProps } from "@mantine/core";
import type { ChangeEvent } from "react";
import { formatPhoneNumber } from "../utils/validation";

type PhoneInputProps = Omit<TextInputProps, "type">;

/** Drop-in for TextInput on phone/fax fields. Formats to (XXX) XXX-XXXX as the user types. */
export function PhoneInput({
  onChange,
  placeholder = "(555) 555-1234",
  ...props
}: PhoneInputProps) {
  return (
    <TextInput
      type="tel"
      placeholder={placeholder}
      {...props}
      onChange={(e: ChangeEvent<HTMLInputElement>) => {
        if (!onChange) return;
        // Mutate e.target.value (the real DOM element) so that
        // Mantine's form handler and custom handlers both read the formatted string.
        e.target.value = formatPhoneNumber(e.target.value);
        onChange(e);
      }}
    />
  );
}
